import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { Title } from '@angular/platform-browser';

// Services
import { UserSessionService } from '../services/user/user.service';
import { LanguageService } from '../services/language/language.service';

// RxJS
import { Subscription } from 'rxjs';

// SEO
import { SeoService } from '../services/seo/seo.service';
import { NgClass } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { AuthService } from '../services/auth/auth.service';

/**
 * Declare plugins so then you can run it
 */
declare function init_plugins(): void;

@Component({
  selector: 'app-restore-password',
  templateUrl: './restore-password.component.html',
  styleUrls: ['./restore-password.component.css'],
  imports: [
    RouterLink,
    FormsModule,
    NgClass,
    MatProgressSpinner,
    TranslocoPipe,
  ],
})
export class RestorePasswordComponent implements OnInit, OnDestroy {
  /**
   * The userEmail variable is declare
   * @param userEmail Variable to save the user’s email
   */
  userEmail!: string;
  /**
   * The language variable is declare
   * @param language Variable to save the actual language
   */
  language!: string;
  //* Boolean to handle submit button style.
  isLoading = false;
  //* Boolean to handle incorrect email.
  isIncorrect = false;
  //* Boolean to handle email sent.
  isEmailSent = false;

  private subscription: Subscription | undefined;

  /**
   * Following variables declared
   * @param router Variable that manage the routes
   * @param languageService Service that applies the selected language by the user
   */
  constructor(
    public router: Router,
    private authService: AuthService,
    public languageService: LanguageService,
    private seoService: SeoService,
    private title: Title,
    private cdr: ChangeDetectorRef,
    private transloco: TranslocoService,
  ) {}

  /**
   * The plugins run
   */
  ngOnInit() {
    init_plugins();
    this.language = this.languageService.getLanguage();

    // SEO
    const title = this.transloco.translate('RESTORE-PASSWORD.FORGOT-PASSWORD');
    const description = this.transloco.translate('COMMON.DESCRIPTION');
    this.title.setTitle(title);
    this.seoService.generateTags({
      title: title,
      description: description,
      slug: 'restore-password',
    });

    this.userEmail = localStorage.getItem('email') || '';
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  recoverPassword(form: NgForm) {
    if (form.invalid) {
      return;
    }

    this.isIncorrect = false;
    this.isLoading = true;

    const body = {
      email: form.value.userEmail.toLowerCase(),
      language: '',
    };

    this.subscription = this.authService.requestPasswordReset(body).subscribe(
      (resp) => {
        this.isLoading = false;
        this.isEmailSent = true;
        this.cdr.markForCheck();
      },
      (error) => {
        this.isIncorrect = true;
        this.isLoading = false;
        this.cdr.markForCheck();
      },
    );
  }

  /**
   * Function to change language localStorage
   * @param language Variable to save the actual language
   */
  changeLanguage(language: string) {
    if (language === 'es' || language === 'en') {
      this.language = language;
      this.languageService.applyLanguage(this.language);
      window.location.reload();
    } else return;
  }
}
